export abstract class BaseRiskModel {

    constructor() { }

}
